import { ILoggingService } from './interfaces';
import { IS_DEV_MODE } from './utils';

export const logError = (error: any, message?: string, source?: string) => {
  if (IS_DEV_MODE) {
    console.log(error);
    console.log(message);
    console.log(source);
  }
};

export const logInfo = (message: string, source?: string, data?: any) => {
  if (IS_DEV_MODE) {
    console.log(message);
    console.log(source);
    console.log(data);
  }
};

export const ConsoleLoggerService = (): ILoggingService => {
  return {
    logError,
    logInfo,
  };
};
